var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8831 8.77344H15.7839C15.5448 8.77344 15.3175 8.88828 15.1769 9.08516L11.4925 14.1945L9.82373 11.8789C9.68311 11.6844 9.45811 11.5672 9.2167 11.5672H8.11748C7.96514 11.5672 7.87608 11.7406 7.96514 11.8648L10.8855 15.9148C10.9544 16.0111 11.0454 16.0896 11.1508 16.1437C11.2561 16.1978 11.3729 16.2261 11.4913 16.2261C11.6098 16.2261 11.7265 16.1978 11.8319 16.1437C11.9372 16.0896 12.0282 16.0111 12.0972 15.9148L17.0331 9.07109C17.1245 8.94688 17.0355 8.77344 16.8831 8.77344Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.70156 2 2 6.70156 2 12.5C2 18.2984 6.70156 23 12.5 23C18.2984 23 23 18.2984 23 12.5C23 6.70156 18.2984 2 12.5 2ZM12.5 21.2188C7.68594 21.2188 3.78125 17.3141 3.78125 12.5C3.78125 7.68594 7.68594 3.78125 12.5 3.78125C17.3141 3.78125 21.2188 7.68594 21.2188 12.5C21.2188 17.3141 17.3141 21.2188 12.5 21.2188Z",
    fill: "#C3C3C3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPositive);
export default __webpack_public_path__ + "static/media/checkPositive.61f5021b4ad7aa0b8c90f70002990b05.svg";
export { ForwardRef as ReactComponent };